import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { LightweightCourseV5 } from '../types'

type UseCourseActionsProps = {
  course: LightweightCourseV5
  navigationUrl: string
  onDelete: (course: LightweightCourseV5) => void
}

export function useCourseActions({
  course,
  navigationUrl,
  onDelete,
}: UseCourseActionsProps) {
  let navigate = useNavigate()

  let handleEdit = useCallback(() => {
    navigate(navigationUrl)
  }, [navigate, navigationUrl])

  let handleDelete = useCallback(() => {
    onDelete(course)
  }, [onDelete, course])

  return {
    handleEdit,
    handleDelete,
  }
}
